/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionsControllerFindAllQueryResponse, TemplateQuestionsControllerFindAllQueryParams, TemplateQuestionsControllerFindAll401, TemplateQuestionsControllerFindAll403 } from "../../models/checklistsController/TemplateQuestionsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templateQuestionsControllerFindAll } from "../../clients/checklistsService/templateQuestionsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templateQuestionsControllerFindAllQueryKey = (params: TemplateQuestionsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-template-questions'
}, ...(params ? [params] : [])] as const;
export type TemplateQuestionsControllerFindAllQueryKey = ReturnType<typeof templateQuestionsControllerFindAllQueryKey>;
export function templateQuestionsControllerFindAllQueryOptions(params?: TemplateQuestionsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templateQuestionsControllerFindAllQueryKey(params);
  return queryOptions<TemplateQuestionsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateQuestionsControllerFindAll401 | TemplateQuestionsControllerFindAll403>, TemplateQuestionsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templateQuestionsControllerFindAll(params, config);
    }
  });
}

/**
 * @description This endpoint supports a higher page size limit of 1000 (default is 100). Use `page[size]=1000` to retrieve up to 1000 records per request.
 * @summary Get all checklist template questions
 * {@link /api/v1/checklist-template-questions}
 */
export function useTemplateQuestionsControllerFindAll<TData = TemplateQuestionsControllerFindAllQueryResponse, TQueryData = TemplateQuestionsControllerFindAllQueryResponse, TQueryKey extends QueryKey = TemplateQuestionsControllerFindAllQueryKey>(params?: TemplateQuestionsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplateQuestionsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateQuestionsControllerFindAll401 | TemplateQuestionsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templateQuestionsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...templateQuestionsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplateQuestionsControllerFindAll401 | TemplateQuestionsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}